export const ServiceList = {
  Title: 'マイメニュー',
  SubTitlePharmacy: '薬局',
  PharmacyService: {
    PharmacySearch: '薬局検索',
    FamilyPharmacy: 'かかりつけ薬局',
    FollowUpMessage: 'メッセージ',
    DispensingReadyCalling: 'お薬できあがり呼出',
  },
  SubTitleTools: '便利ツール',
  ToolsService: {
    Notice: 'お知らせ',
    FamilyList: '家族一覧',
    DataShare: 'お薬手帳の共有',
    Column: 'コラム',
  },
  SubTitleShopping: 'お買い物',
  ShoppingService: {
    EcShop: 'お買い物',
    Coupon: '割引クーポン',
  },
  EditButton: '編集',
};
